import {db} from "@/fb/firebase";

export default {
  methods: {
    saveAccountSettings(settings) {
      const newsettings = {}
      Object.keys(settings).forEach((item) => {
        newsettings['/' + item] = settings[item]
      })

      return db.ref('users/' + this.$store.getters.dataBaseId + '/settings').update(newsettings).then(() => {
        console.log('account updated!')
      })
    },
    saveProfileSettings(profileID, settings, setMethod = false) {
      if (profileID === 'guestProfileAtCurrentDevice') {
        return this.saveGuestProfile(settings)
      } else {
        if (setMethod) {
          return db.ref('users/' + this.$store.getters.dataBaseId + '/settings/profiles/' + profileID).set(settings);
        }

        const newsettings = {}
        Object.keys(settings).forEach((item) => {
          newsettings['/' + item] = settings[item]
        })
        return db.ref('users/' + this.$store.getters.dataBaseId + '/settings/profiles/' + profileID).update(newsettings).then(() => {
          // console.log('profile updated!' , newsettings)
        })
      }
    },
    saveDeviceSettings(deviceID, settings, setMethod = false) {
      if (setMethod) {
        return db.ref('users/' + this.$store.getters.dataBaseId + '/settings/devices/' + deviceID).set(settings);
      }
      const newSettings = {}
      Object.keys(settings).forEach((item) => {
        newSettings['/' + item] = settings[item]
      });
      return db.ref('users/' + this.$store.getters.dataBaseId + '/settings/devices/' + deviceID).update(newSettings).then(() => {
        // console.log('Device updated!')
      })
    },
    saveGuestProfile(settings) {
      const newSettings = {}
      Object.keys(settings).forEach((item) => {
        newSettings['/' + item] = settings[item]
      })
      return db.ref('users/' + this.$store.getters.dataBaseId + '/settings/devices/' + this.$store.state.currentDeviceID + '/guestProfileAtCurrentDevice')
        .update(newSettings).then(() => {
        // console.log('guest profile updated!')
      })
    }
  }
}